import {
  ITEMS_LOADING,
  ITEMS_UPDATE,
  ITEMS_GET,
  CLOSE_LIVE_ITEM
} from 'types/actions/items'
import API from 'store/api'
import serialize from 'store/serialize'
import param from 'jquery-param'
import { omitBy, isNil } from 'lodash'
import { ITEMS_BIDS_LOADING } from 'types/actions/items'
import { ITEMS_BIDS_SET } from 'types/actions/items'
import { ITEMS_SET_BID_ID } from 'types/actions/items'
import { ITEMS_BIDS_PUSH } from 'types/actions/items'
import { ITEMS_BIDS_REMOVE } from 'types/actions/items'
import { ITEMS_BIDS_CLEAR } from 'types/actions/items'

import { ITEMS_PURCHASES_LOADING } from 'types/actions/items'
import { ITEMS_PURCHASES_SET } from 'types/actions/items'
import { ITEMS_SET_PURCHASE_ID } from 'types/actions/items'
import { ITEMS_PURCHASES_PUSH } from 'types/actions/items'
import { ITEMS_PURCHASES_REMOVE } from 'types/actions/items'
import { ITEMS_PURCHASES_CLEAR } from 'types/actions/items'

import { ITEM_PUSH } from 'types/actions/items'

export const setItems = items => ({
  type: ITEMS_GET,
  items
})

export const pushItems = item => ({
  type: ITEM_PUSH,
  item
})

export const setBids = bids => ({
  type: ITEMS_BIDS_SET,
  bids
})

export const setBidId = bid => ({
  type: ITEMS_SET_BID_ID,
  bid
})

export const setPurchases = purchases => ({
  type: ITEMS_PURCHASES_SET,
  purchases
})

export const setPurchaseId = purchase => ({
  type: ITEMS_SET_PURCHASE_ID,
  purchase
})

export const pushBid = bid => ({
  type: ITEMS_BIDS_PUSH,
  bid
})

export const removeBid = bidId => ({
  type: ITEMS_BIDS_REMOVE,
  bidId
})

export const pushPurchase = purchase => ({
  type: ITEMS_PURCHASES_PUSH,
  purchase
})

export const removePurchase = purchaseId => ({
  type: ITEMS_PURCHASES_REMOVE,
  purchaseId
})

export const clearBids = () => ({
  type: ITEMS_BIDS_CLEAR
})

export const clearPurchases = () => ({
  type: ITEMS_PURCHASES_CLEAR
})

export const _setItemsLoading = (loading = false) => ({
  type: ITEMS_LOADING,
  loading
})

export const _setBidsLoading = (loading = false) => ({
  type: ITEMS_BIDS_LOADING,
  loading
})

export const _setPurchasesLoading = (loading = false) => ({
  type: ITEMS_PURCHASES_LOADING,
  loading
})

export const updateItem = (itemId, updates) => ({
  type: ITEMS_UPDATE,
  itemId,
  updates
})

export const closeLiveItem = () => ({
  type: CLOSE_LIVE_ITEM
})

export const getItems = (eventId, stopLoad) => {
  return dispatch => {
    if (!stopLoad) {
      dispatch(_setItemsLoading(true))
    }
    return API.get(`/items/event/${eventId}`)
      .set('Content-Type', 'application/json')
      .retry(1, 500)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(data => {
        serialize(
          'item',
          data.map(d => {
            if (d.image === '[]') {
              d.image = [
                {
                  original_image_name: 'eg_placeholder_xhn1xm'
                }
              ]
            }
            return d
          })
        ).then(response => {
          dispatch(
            setItems(
              response
                .filter(d => d.live_auction || d.item_type === 'fixed')
                .sort((a, b) => a.sort_position - b.sort_position)
            )
          )
          return response
        })
      })
      .finally(() => {
        dispatch(_setItemsLoading(false))
      })
  }
}

export const getItemBids = itemId => {
  return dispatch => {
    dispatch(_setBidsLoading(true))
    return API.get(`/bids/item/${itemId}`)
      .set('Content-Type', 'application/json')
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(data => {
        serialize('bid', data).then(response => {
          response.forEach(bid => {
            dispatch(setBidId(bid))
          })
          dispatch(setBids(response))
          return response
        })
      })
      .finally(() => {
        dispatch(_setBidsLoading(false))
      })
  }
}

export const getItemPurchases = itemId => {
  return dispatch => {
    dispatch(_setPurchasesLoading(true))
    return API.get(`/purchases/item/${itemId}`)
      .set('Content-Type', 'application/json')
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(data => {
        serialize('purchase', data).then(response => {
          response.forEach(purchase => {
            dispatch(setPurchaseId(purchase))
          })
          dispatch(setPurchases(response))
          return response
        })
      })
      .finally(() => {
        dispatch(_setPurchasesLoading(false))
      })
  }
}

export const placeBid = data => {
  return dispatch => {
    return API.post(`/bid`)
      .set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      .send(data)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(response => {
        if (response.msg === 'winner') {
          // dispatch(
          //   updateItem(data.item_id, {
          //     high_bid_user_id: response.item_high_bid_user_id,
          //     high_bid: response.item_high_bid,
          //     bid_count: response.item_bid_count,
          //     high_bid_time: response.item_high_bid_time,
          //     high_bid_id: response.item_high_bid_id
          //   })
          // )
        }
        response.anon = data.anon
        return response
      })
  }
}

export const purchaseFixed = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      return API.post(`/purchaseitem`)
        .set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
        .send(param(omitBy(data, isNil)))
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(response => {
          if (
            response.msg === 'item purchase' ||
            response.msg === 'item purchased' ||
            response.msg === 'item purchase paysession created'
          ) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(reject)
    })
    return deferred
  }
}



// WEBPACK FOOTER //
// ./src/actions/items.js